import { useMemo } from 'react'

import { useAuth } from '@/shared/auth/auth-context'
import { useRuntimeConfig } from '@/shared/config/runtime-config-context'

import { createApiClient, type ApiClient } from './client'

/** The API client every feature uses, bound to the configured base URL and the caller's token. */
export function useApiClient(): ApiClient {
  const { apiBaseUrl } = useRuntimeConfig()
  const { getAccessToken } = useAuth()

  return useMemo(() => createApiClient(apiBaseUrl, getAccessToken), [apiBaseUrl, getAccessToken])
}
